import { z } from "zod";

export const searchSiteContentInputSchema = z.object({
  query: z.string().trim().min(2).max(120),
  limit: z.number().int().min(1).max(10).default(5)
});

export const searchSiteContentResultSchema = z.object({
  id: z.string().min(1),
  title: z.string().min(1),
  path: z.string().min(1),
  summary: z.string().min(1),
  score: z.number().nonnegative(),
  category: z.string().min(1),
  matchedTerms: z.array(z.string())
});

export const searchSiteContentOutputSchema = z.object({
  query: z.string().min(2),
  results: z.array(searchSiteContentResultSchema)
});

export const createContactRequestInputSchema = z.object({
  name: z.string().trim().min(2).max(80),
  email: z.string().trim().email().max(200),
  company: z.string().trim().min(2).max(120),
  message: z.string().trim().min(10).max(2000),
  confirmed: z.boolean().default(false)
});

export const createContactRequestOutputSchema = z.object({
  status: z.enum(["pending_confirmation", "ready"]),
  subject: z.string().min(1),
  mailtoLink: z.string().url(),
  preview: z.string().min(1)
});

const productIdSchema = z.enum(["secure-ai", "rapid-factory", "kyber-docs", "odan", "mawforge"]);

export const generateProductSummaryInputSchema = z.object({
  productId: productIdSchema
});

export const generateProductSummaryOutputSchema = z.object({
  productId: productIdSchema,
  title: z.string().min(1),
  summary: z.string().min(1),
  capabilities: z.array(z.string().min(1))
});

export type SearchSiteContentInput = z.infer<typeof searchSiteContentInputSchema>;
export type SearchSiteContentOutput = z.infer<typeof searchSiteContentOutputSchema>;
export type CreateContactRequestInput = z.infer<typeof createContactRequestInputSchema>;
export type CreateContactRequestOutput = z.infer<typeof createContactRequestOutputSchema>;
export type GenerateProductSummaryInput = z.infer<typeof generateProductSummaryInputSchema>;
export type GenerateProductSummaryOutput = z.infer<typeof generateProductSummaryOutputSchema>;
